module.exports = __webpack_public_path__ + "media/slot-game/percent-9792b316.svg";